module.exports = __webpack_public_path__ + "static/assets/fbc3c4d2c5f0475deb9dfc93da2b3867.jpg";